export default function auth({ next, store }) {
  const { isAuthenticationKeysExists } = store.getters

  if (isAuthenticationKeysExists) {
    return next()
  }

  return next({ name: 'home' })
}
